import React from "react";

const AppContext = React.createContext({
    lahetetty: false,
});

export default AppContext;
